import src from "IMAGE";
export default { src, width: 2, height: 60, blurWidth: 1, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAICAIAAAC3eAIWAAAAIklEQVR42mMwrb3HYNb1kMFizlMGy7UvGKx3vWaw3vcGhgHWow5I/1zNdwAAAABJRU5ErkJggg=="};
